<template>
  <div>
    <b-modal
      hide-footer
      hide-header
      hide-backdrop
      no-fade
      no-enforce-focus
      no-close-on-backdrop
      title="Add Customer Details"
      header-class="addCustomer__header_class"
      modal-class="addCustomer__modal_class"
      title-class="addCustomer__title_class"
      :ref="modalId"
      :id="modalId"
      @show="checkCustomerData"
      @hide="onHideCustomerModal"
    >
      <div class="add_customer_modal">
        <b-tabs content-class="mt-3" v-model="customerTabIndex" pills justified>
          <b-tab
            v-if="['1', '3'].includes(String(popupType))"
            :disabled="disableTab && customerTabIndex == 1"
            title="Customer Details"
            :class="[
              { active: customerTabIndex == 0 },
              { disabled: disableTab },
            ]"
          >
            <div class="col-12 h-100">
              <div class="pos-cust-number">
                <div class="row justify-content-center margin-t40">
                  <form class="row">
                    <div class="col-4 mb-4">
                      <b-dropdown
                        @hide="mobileCodePreventhide"
                        :text="
                          customerDetails['cust_mob_code']
                            ? customerDetails['cust_mob_code']
                            : 'Code'
                        "
                        variant="dropdown-curve"
                        class="w-100 text-center search_code"
                      >
                        <div class="px-2 pb-2">
                          <input
                            required
                            type="search"
                            placeholder="Search Code"
                            class="form-control form-control-sm"
                            v-on:keyup="onSearchCode($event.target.value)"
                            v-on:keydown="onSearchCode($event.target.value)"
                            v-on:search="onSearchCode($event.target.value)"
                            v-model="searchCode"
                            id="searchCode"
                            name="searchCode"
                          />
                        </div>
                        <b-dropdown-item
                          href="#"
                          v-for="(countrycode, countryIndex) in Countries"
                          :key="countryIndex"
                          v-on:click="onSelectHandler(countrycode)"
                          v-if="countrycode.country_mob_code != null"
                          >{{ countrycode.country_mob_code }}
                        </b-dropdown-item>
                      </b-dropdown>
                      <VkeyboardFloat
                        :ID="'searchCode'"
                        :onClickFun="
                          () => {
                            Object.keys(keyboardsVisible).map((x) => {
                              if (x == 'searchCode') {
                                keyboardsVisible[x] = !keyboardsVisible[x];
                              } else {
                                keyboardsVisible[x] = false;
                              }
                            });
                          }
                        "
                      />
                      <Vkeyboard
                        :inputName="'searchCode'"
                        :showOrHide="keyboardsVisible.searchCode"
                        :initialValue="searchCode"
                        @onKeyEnter="
                          (event) => {
                            onSearchCode(event);
                            keyboardsVisible.searchCode = false;
                          }
                        "
                        @changeKeyboardInput="
                          (event) => {
                            searchCode = event;
                            onSearchCode(event);
                          }
                        "
                        @onClickClose="keyboardsVisible.searchCode = false"
                      />
                    </div>
                    <div class="col-8 mb-4">
                      <input
                        type="text"
                        name="cust_mobile"
                        id="cust_mobile"
                        ref="cust_mobile"
                        v-model="customerDetails['cust_mobile']"
                        placeholder="Mobile Number"
                        class="mobile-number"
                        v-on:keydown="
                          (e) => {
                            if (!/[0-9]/.test(e.key) && e.keyCode !== 8) {
                              e.preventDefault();
                            }
                          }
                        "
                      />
                      <VkeyboardFloat
                        :ID="'cust_mobile'"
                        :onClickFun="
                          () => {
                            Object.keys(keyboardsVisible).map((x) => {
                              if (x == 'cust_mobile') {
                                keyboardsVisible[x] = !keyboardsVisible[x];
                              } else {
                                keyboardsVisible[x] = false;
                              }
                            });
                          }
                        "
                      />
                      <Vkeyboard
                        :inputName="'cust_mobile'"
                        :keyBoardType="'numeric'"
                        :showOrHide="keyboardsVisible.cust_mobile"
                        :initialValue="customerDetails['cust_mobile']"
                        @onKeyEnter="keyboardsVisible.cust_mobile = false"
                        @changeKeyboardInput="
                          customerDetails['cust_mobile'] = $event
                        "
                        @onClickClose="keyboardsVisible.cust_mobile = false"
                      />
                    </div>

                    <div v-if="isSearch" class="col-12">
                      <input
                        type="email"
                        v-model="customerDetails['cust_email']"
                        name="cust_email"
                        id="cust_email"
                        placeholder="Email Address"
                        @focus="onClickInputHandler('cust_email')"
                      />
                      <p class="error_message">
                        <span
                          v-if="submitted && !customerDetails['cust_email']"
                          >{{ "Email Required." }}</span
                        >
                      </p>
                      <VkeyboardFloat
                        :ID="'cust_email'"
                        :onClickFun="
                          () => {
                            Object.keys(keyboardsVisible).map((x) => {
                              if (x == 'cust_email') {
                                keyboardsVisible[x] = !keyboardsVisible[x];
                              } else {
                                keyboardsVisible[x] = false;
                              }
                            });
                          }
                        "
                      />
                      <Vkeyboard
                        :inputName="'cust_email'"
                        :showOrHide="keyboardsVisible.cust_email"
                        :initialValue="customerDetails['cust_email']"
                        @onChangeEvent="() => {}"
                        @onKeyEnter="
                          () => {
                            keyboardsVisible.cust_email = false;
                          }
                        "
                        @changeKeyboardInput="
                          customerDetails['cust_email'] = $event
                        "
                        @onClickClose="
                          () => {
                            keyboardsVisible.cust_email = false;
                          }
                        "
                      />
                    </div>
                    <div v-if="isSearch" class="col-6">
                      <input
                        type="text"
                        name="first_name"
                        v-model="customerDetails['first_name']"
                        placeholder="First Name"
                        id="first_name"
                        @focus="onClickInputHandler('first_name')"
                      />
                      <p class="error_message">
                        <span
                          v-if="submitted && !customerDetails['first_name']"
                          >{{ "First Name Required." }}</span
                        >
                      </p>
                      <VkeyboardFloat
                        :ID="'first_name'"
                        :onClickFun="
                          () => {
                            Object.keys(keyboardsVisible).map((x) => {
                              if (x == 'first_name') {
                                keyboardsVisible[x] = !keyboardsVisible[x];
                              } else {
                                keyboardsVisible[x] = false;
                              }
                            });
                          }
                        "
                      />
                      <Vkeyboard
                        :inputName="'first_name'"
                        :showOrHide="keyboardsVisible.first_name"
                        :initialValue="customerDetails['first_name']"
                        @onChangeEvent="() => {}"
                        @onKeyEnter="
                          () => {
                            keyboardsVisible.first_name = false;
                          }
                        "
                        @changeKeyboardInput="
                          customerDetails['first_name'] = $event
                        "
                        @onClickClose="
                          () => {
                            keyboardsVisible.first_name = false;
                          }
                        "
                      />
                    </div>
                    <!--class="col-6 mb-4"-->
                    <div v-if="isSearch" class="col-6">
                      <input
                        type="text"
                        v-model="customerDetails['last_name']"
                        placeholder="Last name"
                        id="last_name"
                        name="last_name"
                        @focus="onClickInputHandler('last_name')"
                      />
                      <p class="error_message">
                        <span
                          v-if="submitted && !customerDetails['last_name']"
                          >{{ "Last Name Required." }}</span
                        >
                      </p>
                      <VkeyboardFloat
                        :ID="'last_name'"
                        :onClickFun="
                          () => {
                            Object.keys(keyboardsVisible).map((x) => {
                              if (x == 'last_name') {
                                keyboardsVisible[x] = !keyboardsVisible[x];
                              } else {
                                keyboardsVisible[x] = false;
                              }
                            });
                          }
                        "
                      />
                      <Vkeyboard
                        :inputName="'last_name'"
                        :showOrHide="keyboardsVisible.last_name"
                        :initialValue="customerDetails['last_name']"
                        @onChangeEvent="() => {}"
                        @onKeyEnter="
                          () => {
                            keyboardsVisible.last_name = false;
                          }
                        "
                        @changeKeyboardInput="
                          customerDetails['last_name'] = $event
                        "
                        @onClickClose="
                          () => {
                            keyboardsVisible.last_name = false;
                          }
                        "
                      />
                    </div>

                    <div
                      v-if="isSearch && CLIENT.QFX == CLIENT_SETUP_NAME"
                      class="col-6"
                    >
                      <input
                        type="text"
                        v-model="customerDetails['cust_pan']"
                        placeholder="PAN No."
                        id="cust_pan"
                        name="cust_pan"
                        @focus="onClickInputHandler('cust_pan')"
                      />
                      <VkeyboardFloat
                        :ID="'cust_pan'"
                        :onClickFun="
                          () => {
                            Object.keys(keyboardsVisible).map((x) => {
                              if (x == 'cust_pan') {
                                keyboardsVisible[x] = !keyboardsVisible[x];
                              } else {
                                keyboardsVisible[x] = false;
                              }
                            });
                          }
                        "
                      />
                      <Vkeyboard
                        :inputName="'cust_pan'"
                        :showOrHide="keyboardsVisible.cust_pan"
                        :initialValue="customerDetails['cust_pan']"
                        @onChangeEvent="() => {}"
                        @onKeyEnter="
                          () => {
                            keyboardsVisible.cust_pan = false;
                          }
                        "
                        @changeKeyboardInput="
                          customerDetails['cust_pan'] = $event
                        "
                        @onClickClose="
                          () => {
                            keyboardsVisible.cust_pan = false;
                          }
                        "
                      />
                    </div>

                    <div
                      v-if="
                        isSearch &&
                        CLIENT.STAR == CLIENT_SETUP_NAME &&
                        !hideInputsFields
                      "
                      class="col-6"
                    >
                      <input
                        type="text"
                        v-model="customerDetails['cust_fazza_essad_no']"
                        placeholder="Fazaa/Essad No."
                        id="cust_fazza_essad_no"
                        name="cust_fazza_essad_no"
                        @focus="onClickInputHandler('cust_fazza_essad_no')"
                      />
                      <VkeyboardFloat
                        :ID="'cust_fazza_essad_no'"
                        :onClickFun="
                          () => {
                            Object.keys(keyboardsVisible).map((x) => {
                              if (x == 'cust_fazza_essad_no') {
                                keyboardsVisible[x] = !keyboardsVisible[x];
                              } else {
                                keyboardsVisible[x] = false;
                              }
                            });
                          }
                        "
                      />
                      <Vkeyboard
                        :inputName="'cust_fazza_essad_no'"
                        :showOrHide="keyboardsVisible.cust_fazza_essad_no"
                        :initialValue="customerDetails['cust_fazza_essad_no']"
                        @onChangeEvent="() => {}"
                        @onKeyEnter="
                          () => {
                            keyboardsVisible.cust_fazza_essad_no = false;
                          }
                        "
                        @changeKeyboardInput="
                          customerDetails['cust_fazza_essad_no'] = $event
                        "
                        @onClickClose="
                          () => {
                            keyboardsVisible.cust_fazza_essad_no = false;
                          }
                        "
                      />
                    </div>

                    <div
                      v-if="
                        isSearch &&
                        CLIENT.EMPIRE != CLIENT_SETUP_NAME &&
                        CLIENT.EPIX != CLIENT_SETUP_NAME &&
                        !hideInputsFields
                      "
                      class="col-12"
                    >
                      <div class="d-flex pb-2">
                        <b-form-checkbox
                          class="j-checkbox"
                          v-model="customerDetails.is_loyality_subscribe"
                          unchecked-value="N"
                          value="Y"
                        ></b-form-checkbox>
                        <span>{{ $t("subscribeloyality") }}</span>
                      </div>
                    </div>
                  </form>
                  <div class="row phone-dial" v-if="!isSearch">
                    <div
                      class="col-4 mb-2"
                      v-for="(value, index) in phone_value"
                      :key="index"
                    >
                      <button
                        v-if="index == phone_value.length - 1"
                        v-on:click="onSliceNumber()"
                        class="number"
                        :disabled="isEdit"
                      >
                        {{ value.name }}
                      </button>
                      <button
                        v-else-if="value.name != ''"
                        v-on:click="onClicknumber(index)"
                        class="number"
                        :disabled="isEdit"
                      >
                        {{ value.name }}
                      </button>
                      <button
                        v-else
                        @click.prevent.stop="onClickDelete"
                        class="number"
                        :disabled="isEdit"
                      >
                        C
                      </button>
                    </div>
                  </div>
                </div>

                <div class="text-center mx-auto my-3">
                  <div class>
                    <button
                      @click="$bvModal.hide(modalId)"
                      class="btn-outline-blue-lg bg-transparent text-dark mr-1"
                    >
                      Cancel
                    </button>
                    <button
                      v-if="!isSearch"
                      v-on:click="onSearchUser()"
                      class="btn-blue-lg bg-blue text-white ml-1"
                    >
                      Search
                    </button>
                    <button
                      v-else-if="isOldCustomer"
                      v-on:click="onUpdateCustomerDetails()"
                      class="btn-blue-lg bg-blue text-white ml-1"
                    >
                      Update
                    </button>
                    <button
                      v-else
                      v-on:click="onSaveDetails()"
                      class="btn-blue-lg bg-blue text-white ml-1"
                    >
                      Save
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </b-tab>

          <b-tab
            v-if="['2', '3'].includes(String(popupType))"
            :disabled="disableTab && customerTabIndex == 0"
            title="Guest User"
            :class="[
              { active: customerTabIndex == 1 },
              { disabled: disableTab },
            ]"
            lazy
          >
            <div class="col-12 h-100">
              <div class="pos-cust-number margin-t40">
                <form class="row">
                  <div class="col-4 mb-4">
                    <b-dropdown
                      :text="
                        guestDetails['guest_mob_code']
                          ? guestDetails['guest_mob_code']
                          : 'Code'
                      "
                      variant="dropdown-curve"
                      class="w-100 text-center mr-3"
                    >
                      <div class="px-2 pb-2">
                        <input
                          required
                          type="search"
                          placeholder="Search Code"
                          class="form-control form-control-sm"
                          v-on:keyup="onSearchCode($event.target.value)"
                          v-on:keydown="onSearchCode($event.target.value)"
                          v-on:search="onSearchCode($event.target.value)"
                          v-model="searchCode"
                          id="searchCode"
                          name="searchCode"
                        />
                      </div>
                      <b-dropdown-item
                        href="#"
                        v-for="(countrycode, countryIndex) in Countries"
                        :key="countryIndex"
                        v-on:click="onSelectHandler(countrycode)"
                        v-if="countrycode.country_mob_code != null"
                        >{{ countrycode.country_mob_code }}
                      </b-dropdown-item>
                    </b-dropdown>
                    <VkeyboardFloat
                      :ID="'searchCode'"
                      :onClickFun="
                        () => {
                          Object.keys(keyboardsVisible).map((x) => {
                            if (x == 'searchCode') {
                              keyboardsVisible[x] = !keyboardsVisible[x];
                            } else {
                              keyboardsVisible[x] = false;
                            }
                          });
                        }
                      "
                    />
                    <Vkeyboard
                      :inputName="'searchCode'"
                      :showOrHide="keyboardsVisible.searchCode"
                      :initialValue="searchCode"
                      @onKeyEnter="
                        (event) => {
                          onSearchCode(event);
                          keyboardsVisible.searchCode = false;
                        }
                      "
                      @changeKeyboardInput="
                        (event) => {
                          searchCode = event;
                          onSearchCode(event);
                        }
                      "
                      @onClickClose="keyboardsVisible.searchCode = false"
                    />
                  </div>
                  <div class="col-8 mb-4">
                    <input
                      type="number"
                      v-model="guestDetails['guest_mobile']"
                      placeholder="Mobile Number"
                      class="mobile-number"
                      id="guest_mobile"
                      name="guest_mobile"
                      v-on:keydown="
                        (e) => {
                          if (!/[0-9]/.test(e.key) && e.keyCode !== 8) {
                            e.preventDefault();
                          }
                        }
                      "
                    />
                    <VkeyboardFloat
                      :ID="'guest_mobile'"
                      :onClickFun="
                        () => {
                          Object.keys(keyboardsVisible).map((x) => {
                            if (x == 'guest_mobile') {
                              keyboardsVisible[x] = !keyboardsVisible[x];
                            } else {
                              keyboardsVisible[x] = false;
                            }
                          });
                        }
                      "
                    />
                    <Vkeyboard
                      :inputName="'guest_mobile'"
                      :showOrHide="keyboardsVisible.guest_mobile"
                      :initialValue="guestDetails['guest_mobile']"
                      @onKeyEnter="keyboardsVisible.guest_mobile = false"
                      @changeKeyboardInput="
                        guestDetails['guest_mobile'] = $event
                      "
                      @onClickClose="keyboardsVisible.guest_mobile = false"
                    />
                  </div>
                  <div class="col-12 mb-4">
                    <input
                      type="email"
                      v-model="guestDetails['guest_email']"
                      name="guest_email"
                      id="guest_email"
                      placeholder="Email Address (Optional)"
                      @focus="onClickInputHandler('guest_email')"
                    />

                    <VkeyboardFloat
                      :ID="'guest_email'"
                      :onClickFun="
                        () => {
                          Object.keys(keyboardsVisible).map((x) => {
                            if (x == 'guest_email') {
                              keyboardsVisible[x] = !keyboardsVisible[x];
                            } else {
                              keyboardsVisible[x] = false;
                            }
                          });
                        }
                      "
                    />
                    <Vkeyboard
                      :inputName="'guest_email'"
                      :showOrHide="keyboardsVisible.guest_email"
                      :initialValue="guestDetails['guest_email']"
                      @onChangeEvent="() => {}"
                      @onKeyEnter="
                        () => {
                          keyboardsVisible.guest_email = false;
                        }
                      "
                      @changeKeyboardInput="
                        guestDetails['guest_email'] = $event
                      "
                      @onClickClose="
                        () => {
                          keyboardsVisible.guest_email = false;
                        }
                      "
                    />
                  </div>
                  <div class="col-6 mb-4">
                    <input
                      type="text"
                      name="guest_first_name"
                      v-model="guestDetails['first_name']"
                      placeholder="First Name"
                      id="guest_first_name"
                      @focus="onClickInputHandler('guest_first_name')"
                    />

                    <VkeyboardFloat
                      :ID="'guest_first_name'"
                      :onClickFun="
                        () => {
                          Object.keys(keyboardsVisible).map((x) => {
                            if (x == 'guest_first_name') {
                              keyboardsVisible[x] = !keyboardsVisible[x];
                            } else {
                              keyboardsVisible[x] = false;
                            }
                          });
                        }
                      "
                    />
                    <Vkeyboard
                      :inputName="'guest_first_name'"
                      :showOrHide="keyboardsVisible.guest_first_name"
                      :initialValue="guestDetails['first_name']"
                      @onChangeEvent="() => {}"
                      @onKeyEnter="
                        () => {
                          keyboardsVisible.guest_first_name = false;
                        }
                      "
                      @changeKeyboardInput="guestDetails['first_name'] = $event"
                      @onClickClose="
                        () => {
                          keyboardsVisible.guest_first_name = false;
                        }
                      "
                    />
                  </div>
                  <!--class="col-6 mb-4"-->
                  <div class="col-6 mb-4">
                    <input
                      type="text"
                      name="guest_last_name"
                      v-model="guestDetails['last_name']"
                      placeholder="Last name"
                      id="guest_last_name"
                      @focus="onClickInputHandler('guest_last_name')"
                    />

                    <VkeyboardFloat
                      :ID="'guest_last_name'"
                      :onClickFun="
                        () => {
                          Object.keys(keyboardsVisible).map((x) => {
                            if (x == 'guest_last_name') {
                              keyboardsVisible[x] = !keyboardsVisible[x];
                            } else {
                              keyboardsVisible[x] = false;
                            }
                          });
                        }
                      "
                    />
                    <Vkeyboard
                      :inputName="'guest_last_name'"
                      :showOrHide="keyboardsVisible.guest_last_name"
                      :initialValue="guestDetails['last_name']"
                      @onChangeEvent="() => {}"
                      @onKeyEnter="
                        () => {
                          keyboardsVisible.guest_last_name = false;
                        }
                      "
                      @changeKeyboardInput="guestDetails['last_name'] = $event"
                      @onClickClose="
                        () => {
                          keyboardsVisible.guest_last_name = false;
                        }
                      "
                    />
                  </div>
                </form>
              </div>

              <div class="text-center mx-auto my-3">
                <div class>
                  <button
                    @click="$bvModal.hide(modalId)"
                    class="btn-outline-blue-lg bg-transparent text-dark mr-1"
                  >
                    Cancel
                  </button>
                  <button
                    v-on:click="onSaveGuestDetails()"
                    class="btn-blue-lg bg-blue text-white ml-1"
                  >
                    Proceed
                  </button>
                </div>
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import Vkeyboard from "@/components/Partials/Vkeyboard.vue";
  import VkeyboardFloat from "@/components/Partials/keyboardFloatingToggle.vue";
  import PosService from "@/services/PosService";
  import MasterService from "@/services/MasterService";
  import { CLIENT_NAME } from "@/helper/Role";

  export default {
    props: {
      modalId: String,
      isRefundModal: {
        type: Boolean,
        default: false,
      },
      onHideModal: {
        type: Function,
        default: null,
      },
      getCallback: {
        type: Function,
        default: null,
      },
      hideGuest: {
        type: Boolean,
        default: false,
      },
      popupType: {
        type: Number,
        default: 2, // 2 for guest 1 for customer 3 for both
      },
      customerDetails_props: {
        type: Object,
        default: () => ({}),
      },
      guestDetails_props: {
        type: Object,
        default: () => ({}),
      },
      hideInputsFields: {
        type: Boolean,
        default: false,
      },
    },
    components: {
      Vkeyboard,
      VkeyboardFloat,
    },
    data() {
      return {
        forceHide: false,
        customerTabIndex: 0,
        disableTab: false,
        selected_id: 1,
        isEdit: false,
        isOldCustomer: false,
        customer_selected_country: "",
        keyboardsVisible: {
          first_name: false,
          last_name: false,
          cust_email: false,
          cust_mobile: false,
          cust_mob_code: false,
          searchCode: false,
          guest_first_name: false,
          guest_last_name: false,
          guest_email: false,
          guest_mobile: false,
          cust_pan: false,
          cust_fazza_essad_no: false,
        },
        Countries: [
          {
            country_id: 191,
            country_name: "Riyadh",
            country_mob_code: "966",
          },
        ],
        CountriesCopy: [
          {
            country_id: 191,
            country_name: "Riyadh",
            country_mob_code: "966",
          },
        ],
        CountriesMethod: {
          GET: "/admin/",
          tableName: "ms_countries",
          urlKey: "countries",
        },
        phone_value: [
          { name: "1" },
          { name: "2" },
          { name: "3" },
          { name: "4" },
          { name: "5" },
          { name: "6" },
          { name: "7" },
          { name: "8" },
          { name: "9" },
          { name: "" },
          { name: "0" },
          { name: "<-" },
        ],
        searchCode: "",
        submitted: false,
        isSearch: false,
        customerDetails: {
          isApplied: "N",
          cust_id: null,
          first_name: "",
          last_name: "",
          cust_email: "",
          cust_mobile: "",
          cust_mob_code: this.defaultMobileCode || "971",
          cust_pan: "",
          cust_fazza_essad_no: "",
          is_loyality_subscribe: "N",
        },
        guestDetails: {
          isApplied: "N",
          guest_id: null,
          guest_user_id: "",
          first_name: "",
          last_name: "",
          guest_email: "",
          guest_mobile: "",
          guest_mob_code: this.defaultMobileCode,
        },
      };
    },
    computed: {
      CLIENT() {
        return CLIENT_NAME;
      },
      operationCountry() {
        return this.$store.getters.operationCountry || "229";
      },
      defaultMobileCode() {
        // return this.$store.getters.defaultMobileCode || "20";
        return (
          this.$store.getters.getOrganizationDetails.org_contact_no_code || "20"
        );
      },
      checkKeyboardOpen() {
        return Object.keys(this.keyboardsVisible).some(
          (x) => this.keyboardsVisible[x] == true
        );
      },
    },
    beforeMount() {},
    mounted() {
      this.getCountriesList();
    },
    beforeDestroy() {},
    methods: {
      mobileCodePreventhide(event) {
        if (!this.forceHide) {
          console.log("event mobileCodePreventhide", event);
          event.preventDefault();
        }
      },
      mobileCodePreventAllow(event) {
        console.log("mobileCodePreventAllow", event);
        this.forceHide = true;
        setTimeout(() => {
          this.forceHide = false;
        }, 1000);
      },
      onChangeCode() {},
      checkCustomerData() {
        Object.keys(this.customerDetails_props).map((key) => {
          this.customerDetails[key] = this.customerDetails_props[key]
            ? this.customerDetails_props[key]
            : this.customerDetails[key];
        });
        Object.keys(this.guestDetails_props).map((key) => {
          this.guestDetails[key] = this.guestDetails_props[key]
            ? this.guestDetails_props[key]
            : this.guestDetails[key];
        });

        if (this.customerDetails["isApplied"] == "Y") {
          // this.isSearch = true;
          this.customerDetails["cust_mobile"] = "";
          this.isEdit = true;
          this.disableTab = true;
          this.isOldCustomer = true;
          this.customerTabIndex = 0;
        } else if (this.guestDetails["isApplied"] == "Y") {
          this.isSearch = true;
          this.isEdit = true;
          this.disableTab = true;
          this.customerTabIndex = 1;
        } else {
          this.isSearch = false;
          this.isOldCustomer = false;
          this.isEdit = false;
          this.disableTab = false;
        }
      },
      onSliceNumber() {
        this.customerDetails["cust_mobile"] = this.customerDetails[
          "cust_mobile"
        ].slice(0, -1);
      },
      onClicknumber(index) {
        // this.$refs.cust_mobile.focus();
        this.customerDetails["cust_mobile"] += this.phone_value[index].name;
      },
      onClickDelete() {
        this.customerDetails["cust_mobile"] = "";
      },
      onSearchUser() {
        if (!this.customerDetails["cust_mob_code"]) {
          this.$toasted.show("Please Select Country Code.");
        } else if (!this.customerDetails["cust_mobile"]) {
          this.$toasted.show("Please enter Mobile Number.");
        } else {
          let payload = {
            sb_mobile_number: this.customerDetails["cust_mobile"],
            check_mob_code: false,
            country_mob_code: this.customerDetails["cust_mob_code"],
          };

          PosService.UpdateCustomerBookingDetails(payload).then((response) => {
            const { data } = response;
            if (data && data.status) {
              let customerDetails = data.Records[0];
              Object.keys(this.customerDetails).map((key) => {
                this.customerDetails[key] = customerDetails[key]
                  ? customerDetails[key]
                  : this.customerDetails[key];
              });
              this.customerDetails["isApplied"] = "Y";
              Object.keys(this.customerDetails_props).map((key) => {
                this.customerDetails_props[key] = this.customerDetails[key]
                  ? this.customerDetails[key]
                  : this.customerDetails_props[key];
              });
              this.$emit("onAddCustomer", this.customerDetails);
              this.isOldCustomer = true;
              this.$bvModal.hide(this.modalId);
            } else {
              this.isOldCustomer = false;
              this.customerDetails["isApplied"] = "N";
              this.isSearch = true;
              this.isEdit = true;
            }
          });
        }
      },
      onSaveDetails() {
        this.submitted = true;
        if (!this.customerDetails["cust_mob_code"]) {
          this.$toasted.show("Please Select Country Code.");
        } else if (!this.customerDetails["cust_mobile"]) {
          this.$toasted.show("Please enter Mobile Number.");
        } else if (!this.customerDetails["first_name"]) {
          this.$toasted.show("Please enter First Name.");
        } else {
          let payload = {
            first_name: this.customerDetails["first_name"],
            is_loyality_subscribe:
              this.customerDetails["is_loyality_subscribe"],
            last_name: this.customerDetails["last_name"],
            mobile_number: this.customerDetails["cust_mobile"],
            cust_email: this.customerDetails["cust_email"],
            cust_id: this.customerDetails["cust_id"],
            country_mob_code: this.customerDetails["cust_mob_code"],
            cust_pan: this.customerDetails["cust_pan"],
            cust_fazza_essad_no: this.customerDetails["cust_fazza_essad_no"],
            hideModalIfFound: this.isRefundCustomer ? true : false,
          };
          PosService.InsertOnlyCustomerDetails(payload).then((response) => {
            const { data } = response;
            if (
              data &&
              data.status &&
              data.hasOwnProperty("Customer_ID") &&
              data.Customer_ID.length > 0
            ) {
              this.customerDetails["isApplied"] = "Y";
              this.customerDetails["cust_id"] = data.Customer_ID[0];
              Object.keys(this.customerDetails_props).map((key) => {
                this.customerDetails_props[key] = this.customerDetails[key]
                  ? this.customerDetails[key]
                  : this.customerDetails_props[key];
              });
              this.$emit("onAddCustomer", this.customerDetails);
              this.$toasted.show(data.message);
              this.$bvModal.hide(this.modalId);
            } else {
              this.customerDetails["isApplied"] = "N";
              this.$toasted.show(data.message || "No Customer Found");
            }
          });
        }
      },
      onSaveGuestDetails() {
        this.submitted = true;
        if (!this.guestDetails["guest_mob_code"]) {
          this.$toasted.show("Please Select Country Code.");
        } else if (!this.guestDetails["guest_mobile"]) {
          this.$toasted.show("Please enter Mobile Number.");
        } else {
          let payload = {
            guest_user_id: Math.floor(Math.random() * 9000000000),
            guest_email: this.guestDetails["guest_email"]
              ? this.guestDetails["guest_email"]
              : `${this.guestDetails["guest_mobile"]}@brij.tech`,
            guest_first_name: this.guestDetails["first_name"],
            guest_last_name: this.guestDetails["last_name"],
            guest_mobile: this.guestDetails["guest_mobile"],
            guest_country_code: this.guestDetails["guest_mob_code"],
            checkValidation: false,
          };
          PosService.InsertGuestDetails(payload).then((response) => {
            const { data } = response;
            if (
              data &&
              data.status &&
              data.hasOwnProperty("data") &&
              data.data.length > 0
            ) {
              this.guestDetails["guest_id"] = data.data[0].guest_id;
              this.guestDetails["guest_user_id"] = data.data[0].guest_user_id;
              this.guestDetails["guest_email"] = data.data[0].guest_email
                ? data.data[0].guest_email
                : "";
              this.guestDetails["first_name"] =
                data.data[0].guest_first_name || "";
              this.guestDetails["last_name"] =
                data.data[0].guest_last_name || "";
              this.guestDetails["guest_mobile"] =
                data.data[0].guest_mobile || "";
              this.guestDetails["guest_mob_code"] =
                data.data[0].guest_country_code || "";
              this.guestDetails["isApplied"] = "Y";
              console.log("this.guestDetails", this.guestDetails);
              Object.keys(this.guestDetails_props).map((key) => {
                this.guestDetails_props[key] = this.guestDetails[key]
                  ? this.guestDetails[key]
                  : this.guestDetails_props[key];
              });
              this.$emit("onAddGuestCustomer", this.guestDetails);
              // this.$toasted.show(data.message);
              this.$bvModal.hide(this.modalId);
            } else {
              this.guestDetails["isApplied"] = "N";
              this.$toasted.show(data.message || "No Customer Found");
            }
          });
        }
      },
      onUpdateCustomerDetails() {
        if (!this.customerDetails["cust_mob_code"]) {
          this.$toasted.show("Please Select Country Code.");
        } else if (!this.customerDetails["cust_mobile"]) {
          this.$toasted.show("Please enter Mobile Number.");
        } else {
          let payload = {
            first_name: this.customerDetails["first_name"],
            is_loyality_subscribe:
              this.customerDetails["is_loyality_subscribe"],
            last_name: this.customerDetails["last_name"],
            mobile_number: this.customerDetails["cust_mobile"],
            cust_email: this.customerDetails["cust_email"],
            cust_id: this.customerDetails["cust_id"],
            country_mob_code: this.customerDetails["cust_mob_code"],
            cust_pan: this.customerDetails["cust_pan"],
            cust_fazza_essad_no: this.customerDetails["cust_fazza_essad_no"],
            hideModalIfFound: this.isRefundCustomer ? true : false,
          };

          PosService.updateCustomerData(payload).then((response) => {
            const { data } = response;
            if (data && data.status) {
              this.customerDetails["isApplied"] = "Y";
              Object.keys(this.customerDetails_props).map((key) => {
                this.customerDetails_props[key] = this.customerDetails[key]
                  ? this.customerDetails[key]
                  : this.customerDetails_props[key];
              });
              this.$emit("onAddCustomer", this.customerDetails);
              this.$toasted.show(data.message);
              this.$bvModal.hide(this.modalId);
            } else {
              this.customerDetails["isApplied"] = "N";
              this.$toasted.show(data.message || "No Customer Found");
            }
          });
        }
      },
      onClickInputHandler(event) {
        console.log("INSIDE onClickInputHandler click happpens", event);
        if (
          Object.keys(this.keyboardsVisible).some(
            (x) => this.keyboardsVisible[x] == true
          )
        ) {
          Object.keys(this.keyboardsVisible).map((x) => {
            this.keyboardsVisible[x] = false;
          });
          this.keyboardsVisible[event] = true;
          this.$forceUpdate();
        }
      },
      onHideCustomerModal() {
        this.customerDetails = {
          isApplied: "N",
          cust_id: null,
          first_name: "",
          last_name: "",
          cust_email: "",
          cust_mobile: "",
          cust_mob_code: this.defaultMobileCode,
          cust_pan: "",
          cust_fazza_essad_no: "",
          is_loyality_subscribe: "N",
        };
        this.guestDetails = {
          isApplied: "N",
          guest_id: "",
          guest_user_id: "",
          first_name: "",
          last_name: "",
          guest_email: "",
          guest_mobile: "",
          guest_mob_code: this.defaultMobileCode,
        };
        this.$emit("onHideModal");
      },
      onSearchCode() {
        if (this.searchCode && this.searchCode.length > 0) {
          this.Countries = this.CountriesCopy.filter((x) => {
            if (
              x.country_mob_code &&
              x.country_mob_code
                .toLowerCase()
                .includes(this.searchCode.toLowerCase())
            ) {
              return x;
            }
          });
        } else {
          this.Countries = this.CountriesCopy;
        }
      },
      onSelectHandler(countryCode) {
        this.forceHide = true;
        this.customer_selected_country = countryCode;
        this.customerDetails["cust_mob_code"] = countryCode["country_mob_code"];
        this.guestDetails["guest_mob_code"] = countryCode["country_mob_code"];
        this.$forceUpdate();
        setTimeout(() => {
          this.forceHide = false;
        }, 1000);
      },
      getCountriesList: function () {
        this.Countries = [];
        let body = this.getRequestBody("GET", undefined, this.CountriesMethod);
        MasterService.GlobalRequest(body)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.Countries = data.Records;
              this.CountriesCopy = data.Records;
              let defaultCon = data.Records.filter((c) => {
                console.log(
                  this.operationCountry,
                  "OPERATION_COUNTRY Inside Popup"
                );
                return c.country_id == this.OPERATION_COUNTRY;
              });
              console.log("defaultCon", defaultCon);
              if (defaultCon.length > 0) {
                this.customerDetails["cust_mob_code"] =
                  defaultCon[0]["country_mob_code"];
                this.guestDetails["guest_mob_code"] =
                  defaultCon[0]["country_mob_code"];
                this.onSelectHandler(defaultCon[0]);
              }
              this.customerDetails["cust_mob_code"] =
                this.$store.getters.getOrganizationDetails.org_contact_no_code;
              this.guestDetails["guest_mob_code"] =
                this.$store.getters.getOrganizationDetails.org_contact_no_code;
            } else {
              console.log("show error :", data.message);
            }
          })
          .catch((error) => {
            console.log("show error :", error);
          });
      },
    },
  };
</script>
<style>
  .disbled-section {
    cursor: not-allowed;
    opacity: 0.4;
  }

  .add_customer_modal .nav-pills .nav-link {
    background: lightgrey;
    color: black;
    font-weight: 500;
    border: 0;
    border-radius: 0.25rem;
    height: 45px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .add_customer_modal .nav-pills .nav-link.active {
    color: #fff !important;
    background: var(--blue) !important;
  }

  .add_cust .multiselect__placeholder,
  .add_cust .multiselect__single {
    font-size: 13px !important;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .addCustomer__title_class {
    font-size: 12px !important;
  }

  .addCustomer__header_class {
    padding: 0.4rem 1rem !important;
  }

  .customerDetails___BV_modal_body_ {
    padding: 0.4rem 1rem !important;
  }

  .pos-cust-number {
    margin: 0 auto;
    max-width: 275px;
  }

  .pos-cust-number input {
    width: 100%;
    border: none;
    display: block;
    padding: 0 15px;
    background: none;
    min-height: 40px;
    overflow: hidden;
    border-radius: 10px;
    transition: 0.3s ease;
    /* border: 1px solid #d3d3d3; */
    border: 1px solid grey;
    height: 45px;
  }

  .pos-cust-number input:focus {
    outline: none;
    border: 2px solid var(--blue);
    background: none;
  }

  .pos-cust-number button:active {
    transform: scale(0.95);
  }

  .pos-cust-number .btn-dropdown-curve,
  .pos-cust-number .mobile-number {
    padding-left: 10px !important;
    padding-right: 10px !important;
    /* background: #eaeaed; */
    border: 1px solid grey;
    height: 45px;
  }

  .phone-dial {
    margin: 0;
    padding: 3px;
  }

  .margin-t40 {
    margin-top: 40px;
  }

  /* .pos-cust-number button.number {
  border: 1px solid darkgrey;
  box-shadow: 0px 1px 1px 0px black;
  width: 90px;
  height: 55px;
  display: flex;
  line-height: 1;
  margin: 0 auto;
  font-size: 20px;
  font-weight: 500;
  border-radius: 10%;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s;
} */
  .pos-cust-number button.number {
    border: 0;
    width: 55px;
    height: 55px;
    color: #fff;
    display: flex;
    line-height: 1;
    margin: 0 auto;
    font-size: 20px;
    border-radius: 50%;
    align-items: center;
    justify-content: center;
    background-color: var(--blue);
    transition: transform 0.2s;
  }
</style>



// WEBPACK FOOTER //
// src/components/Partials/NewCustomerDetailsPopup.vue